import { Injectable } from '@angular/core';
import { RestService } from '../../services/common';

@Injectable({ providedIn: 'root' })
export class VaultService {
    constructor(private rest: RestService) { }

    amendTransaction(dto: any) {
        return this.rest.postData(
            `amend`,
            dto
        );
    }

    filterVaultPayList() {
        return this.rest.getData(`vault/cout`);
    }

    filterVaultReceiveList() {
        return this.rest.getData(`vault/cin`);
    }

    getLedger(ledgerRequestObj: any) {
        return this.rest.postData(`vault/ledger`, ledgerRequestObj);
    }
}